import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { InputNumber } from "primereact/inputnumber";
import React from "react";

interface SelectAxisMinMaxProps {
  currentYAxisRange: { min: number | undefined; max: number | undefined } | undefined;
  setYAxisRange: (currentYAxisRange: { min: number | undefined; max: number | undefined }) => void;
}

const SelectAxisMinMax = (props: SelectAxisMinMaxProps) => {
  const currentYAxisRange = props.currentYAxisRange || { min: 0, max: 0 };

  const handleMinChange = (e: { value: number | null }) => {
    if (e.value && currentYAxisRange.max && e.value >= currentYAxisRange?.max) {
      easasAlert({
        summary: "Error",
        detail: "Min value must be less than max value",
        severity: "error",
        life: 3000,
      });
      return;
    }
    const newValue = e.value !== null ? e.value : undefined;
    props.setYAxisRange({ min: newValue, max: currentYAxisRange.max });
  };

  const handleMaxChange = (e: { value: number | null }) => {
    if (e.value && currentYAxisRange.min && e.value <= currentYAxisRange?.min) {
      easasAlert({
        summary: "Error",
        detail: "Max value must be greater than min value",
        severity: "error",
        life: 3000,
      });
      return;
    }
    const newValue = e.value !== null ? e.value : undefined;
    props.setYAxisRange({ min: currentYAxisRange.min, max: newValue });
  };

  return (
    <div className="p-fluid p-formgrid p-grid gap-3 mr-3 mt-3">
      <div className="p-field">
        <label htmlFor="min">Min</label>
        <InputNumber id="min" value={currentYAxisRange.min || 0} onValueChange={handleMinChange} />
      </div>
      <div className="p-field">
        <label htmlFor="max">Max</label>
        <div className="flex flex-row gap-2">
          <InputNumber
            id="max"
            value={currentYAxisRange.max || 0}
            onValueChange={handleMaxChange}
          />
          <i
            className="pi pi-refresh ml-2 cursor-pointer align-self-center"
            onClick={() => props.setYAxisRange({ min: undefined, max: undefined })}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectAxisMinMax;
